function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 25 0 25 22 0 22"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "hea-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.3106164,11.0614167 L18.3097052,11.0614167 C18.3097052,11.49225 17.9625471,11.8415 17.5342942,11.8415 L14.2185236,11.8415 L14.2185236,15.1790833 C14.2185236,15.609 13.8704542,15.95825 13.4422014,15.95825 L11.5469546,15.95825 C11.1187017,15.95825 10.7724547,15.609 10.7724547,15.1790833 L10.7724547,11.8415 L7.45577296,11.8415 C7.02660891,11.8415 6.67945073,11.49225 6.67945073,11.0614167 L6.67945073,9.15475 C6.67945073,8.72391667 7.02660891,8.37466667 7.45577296,8.37466667 L10.7724547,8.37466667 L10.7724547,5.038 C10.7724547,4.60625 11.1196129,4.25791667 11.5469546,4.25791667 L13.4422014,4.25791667 C13.8713654,4.25791667 14.2185236,4.60625 14.2185236,5.038 L14.2185236,8.37466667 L17.5342942,8.37466667 C17.9634582,8.37466667 18.3106164,8.72391667 18.3106164,9.15475 L18.3106164,11.0614167 Z M23.7394049,2.78208333 C22.5065833,1.03766667 20.4992619,0 18.3643758,0 L18.2759917,0 C15.4458781,0 13.4668031,1.21641667 12.4936668,1.99008333 C11.5187081,1.21733333 9.53507731,0 6.72500955,0 C6.6922072,0 6.65849368,0 6.62660251,0 C4.51449581,0 2.51537497,1.04683333 1.2716193,2.80591667 C-0.14617105,4.8125 -0.387632774,7.447 0.593704119,10.2263333 C2.60467025,15.9270833 11.6225822,21.6195833 12.0052763,21.8588333 C12.1556204,21.9523333 12.3260104,22 12.494578,22 C12.664968,22 12.8344468,21.9523333 12.9847908,21.8588333 C13.3674849,21.6195833 22.3853969,15.9270833 24.3972742,10.2263333 C25.3859005,7.42408333 25.1526394,4.78041667 23.7394049,2.78208333 L23.7394049,2.78208333 Z",
  fill: "#FEFEFE",
  mask: "url(#hea-mask-2)"
})));

var SvgHealthPromotionMeasures = function SvgHealthPromotionMeasures(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthPromotionMeasures, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/health-promotion-measures.547437ef.svg";
export { ForwardRef as ReactComponent };